// app/page.js  (NO 'use client' here!  This is a server component.)

// ==================
// 1. SEO Metadata Block (used automatically by Next.js to populate <head>)
// ==================
"use client";

import Script from "next/script";
import Category from "./Components/Category";

import { getAllCategoryIcons } from "./config/categoryMapping";
import { preloadCategoryIcons } from "./lib/preLoad";
import { useEffect } from "react";

// export const metadata = {
//   title: "Best Home Salon Services in Gurugram | SortKaro",
//   description:
//     "Experience luxury salon services at home in Gurugram with SortKaro. Get professional beauty treatments for facials, waxing, manicures & more. Book now!",
//   keywords:
//     "home salon Gurugram, salon services at home, beauty services Gurgaon, facial at home, waxing services Gurugram",
//   // OpenGraph: for Facebook/WhatsApp/etc rich sharing
//   openGraph: {
//     title: "Best Home Salon Services in Gurugram | SortKaro",
//     description:
//       "Luxury beauty services at home in Gurgaon. Book professional facials, waxing & more.",
//     url: "https://www.sortkaro.com",
//     type: "website",
//     images: [
//       // You can add social card here:
//       // {
//       //   url: "https://www.sortkaro.com/og-image.jpg",
//       //   width: 1200,
//       //   height: 630,
//       //   alt: "SortKaro - Home Salon Services in Gurugram"
//       // }
//     ],
//   },
//   // Twitter Card metadata for sharing
//   twitter: {
//     card: "summary_large_image",
//     // title/description/images can be copied from above if needed
//   },
//   robots: { index: true, follow: true }, // Search engine instructions
// };

// ==================
// 2. JSON-LD Schema Block (optional, for rich Google results)
// ==================

const schemaMarkup = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "SortKaro",
  url: "https://www.sortkaro.com",
  description:
    "Get house help in just 10 minutes with SortKaro. Book kitchen cleaning, bathroom cleaning, dusting, utensils washing, laundry, sweeping & mopping, balcony cleaning, water tank cleaning, and more. Trusted home services at affordable prices in Gurugram.",
  image:
    "https://res.cloudinary.com/dhj6ecd6w/image/upload/v1738695528/catalog/logo.png",
  logo: "https://res.cloudinary.com/dhj6ecd6w/image/upload/w_48,h_48/v1738695528/catalog/logo.png",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Gurugram, Haryana, India",
    addressLocality: "Gurugram",
    addressRegion: "HR",
    postalCode: "122001",
    addressCountry: "IN",
  },
  telephone: "+918800860561",
  priceRange: "₹",
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
      opens: "09:00",
      closes: "20:00",
    },
  ],
  sameAs: [
    "https://www.instagram.com/sortkaroo",
    "https://x.com/sortkaroservice",
  ],
};

const serviceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  name: "Home Cleaning Services",
  description:
    "Professional home cleaning and house help services in Gurugram including kitchen cleaning, bathroom cleaning, laundry, and more.",
  provider: {
    "@type": "Organization",
    name: "SortKaro",
  },
  areaServed: {
    "@type": "City",
    name: "Gurugram",
  },
  serviceType: "Home Cleaning",
};

// ==================
// 3. Your actual UI rendering
// ==================

export default function HomePage() {
  useEffect(() => {
    const allIcons = getAllCategoryIcons();
    preloadCategoryIcons(allIcons);
  }, []);

  return (
    <>
      {/* Schema.org for Google rich snippets */}
      <Script
        id="organization-schema"
        type="application/ld+json"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaMarkup) }}
      />
      <Script
        id="service-schema"
        type="application/ld+json"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(serviceSchema) }}
      />
      {/* Main Home UI */}
      <Category />
      {/* Upcoming Bookings Overlay */}
      {/* <UpcomingBookingsOverlay /> */}
      {/* Add other components here if your home page needs more */}
    </>
  );
}
